import axios from "axios";
import { useEffect, useState } from "react";

import { UserInfo } from "../types/domain/User";
import useAccessRejectedInterceptor from "./useAccessRejectedInterceptor";
import useAccessForbiddenInterceptor from "./useAccessForbiddenInterceptor";
import useGlobalErrorHandler from "./useGlobalErrorHandler";
import useAuthorizationHeader from "./useAuthorizationHeader";

const useAxiosConfig = (
  userData: UserInfo | null | undefined,
  setData: (data: any) => void,
  apiBaseUrl?: string,
  refreshTokenUrl?: string,
  isWithCredentials = false,
  clientId?: string,
  forbiddenCallback?: () => void,
  refreshTokenBaseUrl?: string
) => {
  const [isReady, setIsReady] = useState(false);
  const isLoggedIn = useAuthorizationHeader(userData?.token);

  useGlobalErrorHandler();

  useAccessRejectedInterceptor(
    userData,
    setData,
    refreshTokenUrl,
    isWithCredentials,
    clientId,
    refreshTokenBaseUrl
  );

  useAccessForbiddenInterceptor(forbiddenCallback);

  useEffect(() => {
    axios.defaults.baseURL = apiBaseUrl;
    setIsReady(true);
  }, [apiBaseUrl]);

  return isReady && isLoggedIn !== null;
};

export default useAxiosConfig;
